<template>
  <canvas ref="confettiCanvas" class="full-screen-confetti"></canvas>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref, useTemplateRef } from 'vue'
import confetti from 'canvas-confetti'
import { BRAND_BLUE_100, LIGHT_BLUE, PURPLE, DARK_PURPLE, GREEN, DARK_TEAL } from '@/utils/charts'

/** PROPS **/
const props = defineProps({
  showConfetti: {
    type: Boolean,
    default: false,
  },
})

/** STATE **/
const confettiCanvas = useTemplateRef('confettiCanvas')
const activeCanvas = ref<any | null>(null)

/** LIFECYCLE **/
onMounted(() => {
  if (props.showConfetti) {
    nextTick(() => showConfettiPop())
  }
})

/** METHODS **/

/**
 * @see https://www.kirilv.com/canvas-confetti/
 *
 * Using "relatistic look" example as reference
 */
function showConfettiPop() {
  // stop any existing animation before loading a new one
  if (activeCanvas.value) {
    activeCanvas.value.reset()
  }

  const customCanvasConfetti = confetti.create(confettiCanvas.value, { resize: true })
  activeCanvas.value = customCanvasConfetti

  // get width and lower confetti pop for mobile devices
  // desktop can have more closer to middle
  const originY = window.innerWidth <= 415 ? 0.7 : 0.6

  console.warn('window.innerWidth', window.innerWidth, originY)

  // animation keyframe request stop (ms)
  const end = Date.now() + 5

  const particleCount = 200

  const frame = function () {
    if (Date.now() < end) {
      const opts = {
        origin: { y: originY },
        disableForReducedMotion: true,
      }

      customCanvasConfetti({
        ...opts,
        spread: 26,
        startVelocity: 55,
        particleCount: Math.floor(particleCount * 0.25),
        colors: [DARK_PURPLE, PURPLE],
      })

      customCanvasConfetti({
        ...opts,
        particleCount: Math.floor(particleCount * 0.2),
        spread: 60,
        colors: [BRAND_BLUE_100, LIGHT_BLUE],
      })

      customCanvasConfetti({
        ...opts,
        particleCount: Math.floor(particleCount * 0.35),
        spread: 100,
        decay: 0.91,
        scalar: 0.8,
        colors: [DARK_TEAL, GREEN],
      })

      customCanvasConfetti({
        ...opts,
        particleCount: Math.floor(particleCount * 0.1),
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2,
        colors: [DARK_PURPLE, PURPLE],
      })

      customCanvasConfetti({
        ...opts,
        particleCount: Math.floor(particleCount * 0.1),
        spread: 120,
        startVelocity: 45,
        colors: [DARK_TEAL, GREEN],
      })

      requestAnimationFrame(frame)
    }
  }

  // invoke
  frame()
}
</script>
